var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ac-gantt-chart',{attrs:{"tasks":_vm.tasks,"options":_vm.options,"show_toolbar":true,"toolbar_title":"My custom title"}})}
var staticRenderFns = []

export { render, staticRenderFns }